import { useEffect, useMemo, useState } from "react"
import { useDispatch, useSelector } from "react-redux"

import { noteActionsOptions, noteTypesOptions } from "../../../../lib/systemData"
import { canSeeCaseNotesTab, canUseNoteTypeId, filterNoteTypesByPermission, filterNotesByPermission } from "../../../../lib/notesPermissions"
import { caseNotesForViewer } from "../../../../lib/noteDelete"
import { notesActions } from "../../../../store/notes"
import Button from "../../../common/Button"
import InputBox from "../../../common/interactive/InputBox"
import CustomSelect from "../../../common/interactive/CustomSelect"

import classes from './NotesFilters.module.css'

const NOTES_VS_TASKS = [
    {
        label: 'All',
        value: ''
    },
    {
        label: 'Notes',
        value: 'notes'
    },
    {
        label: 'Tasks (active)',
        value: 'task'
    },
    {
        label: 'Tasks (all)',
        value: 'task_all'
    },
]

const NotesFilters = () => {
    const dispatch = useDispatch()

    const activeCase = useSelector(state => state.case.activeCase)
    const preselectedNotesType = useSelector(state => state.details.notesType)
    const editPermissions = useSelector(state => state.permissions.editPermissions)
    const userPermissions = useSelector(state => state.user.user?.permissions)
    const canSeeNotesTab = useMemo(
        () => canSeeCaseNotesTab(userPermissions, editPermissions, activeCase),
        [userPermissions, editPermissions, activeCase]
    )
    const permittedNotes = useMemo(
        () => caseNotesForViewer(filterNotesByPermission([...(activeCase?.notes || [])], editPermissions), canSeeNotesTab),
        [activeCase?.notes, editPermissions, canSeeNotesTab]
    )
    const permittedNoteTypes = useMemo(
        () => filterNoteTypesByPermission(noteTypesOptions() || [], editPermissions),
        [editPermissions]
    )

    const [usersOptions, setUsersOptions] = useState(null)
    const [selectedUser, setSelectedUser] = useState(null)
    const [selectedUseriD, setSelectedUserId] = useState(null)
    const [selectedNoteTypeId, setSelectedNoteTypeId] = useState(null)
    const [selectedActionId, setSelectedActionId] = useState(null)
    const [keyword, setKeyword] = useState(null)

    const [taskVsNotes, setTaskVsNotes] = useState(null)

    const sortedPermittedNotes = () => [...permittedNotes].sort(function(x, y) {
        return new Date(y.created_at) - new Date(x.created_at)
    })

    useEffect(() => {
        if (preselectedNotesType) {
            if (!canUseNoteTypeId(preselectedNotesType, editPermissions)) {
                setSelectedNoteTypeId(null)
                return
            }

            setSelectedNoteTypeId(preselectedNotesType)

            let arr = sortedPermittedNotes()

            if (arr) {
                let results = arr.filter(item => item.note_type_id == preselectedNotesType)     
                dispatch(notesActions.setFilterResult(results))
            }
        }
    }, [preselectedNotesType, editPermissions, permittedNotes])

    useEffect(() => {

        let arr = [...permittedNotes]

        if (arr) {
            let users = []
            arr.forEach(item => {               
                if (users.length > 0) {

                    if (item.user) {
                        const index = users.findIndex(object => {
                            return object.value == item.user.id
                        })

                        if (index < 0) {
                            users.push({
                                label: item.user.name,
                                value: item.user.id
                            })
                        }
                    } else {
                        const index = users.findIndex(object => {
                            return object.value == 'System'
                        })
                        if (index < 0) {
                            users.push({
                                label: 'System',
                                value: 'System'
                            })
                        }
                    }
                    
                } else {
                    if (item.user) {
                        users.push({
                            label: item?.user?.name,
                            value: item?.user?.id
                        })
                    } else {
                        users.push({
                            label: 'System',
                            value: 'System'
                        })
                    }
                    
                    
                }
                
            })

            setUsersOptions(users)
            
        }

    }, [permittedNotes])

    const filterNotesVSTasks = (value) => {
        setTaskVsNotes(value.data.value)

        let arr = sortedPermittedNotes()


        if (arr) {            
            // let results = arr.filter(item => item.user_id == value.data.value)
            let results = arr
            if (value.data.value) {
                if (value.data.value == 'notes') {
                    results = arr.filter(item => !item.is_task)
                }

                if (value.data.value == 'task') {
                    results = arr.filter(item => item.is_task && !item.assignee_resolved && !item.resolved)
                }

                if (value.data.value == 'task_all') {
                    results = arr.filter(item => item.is_task)
                }
                
            } 

            if (keyword) { //keyword search
                results = results.filter(item => item.note?.toLowerCase().includes(keyword?.toLowerCase()) 
                || item.assignee_resolved_note?.toLowerCase().includes(keyword?.toLowerCase())
                || item.resolved_note?.toLowerCase().includes(keyword?.toLowerCase()))
            } 
            if (selectedActionId !== null) { //action
                results = results.filter(item => item.note_action_id == selectedActionId)
            }
            if (selectedNoteTypeId !== null) { //type
                results = results.filter(item => item.note_type_id == selectedNoteTypeId)
            }  
            if (selectedUseriD !== null) { //user
                // results = results.filter(item => item.user_id == selectedUseriD)
                results = results.filter(item => {
                    // value.data.value == 'System' ? item.user_id == 0 : item.user_id == value.data.value
                    if (selectedUseriD == 'System') {
                        return  item.user_id == 0
                    } 
                    
                    return item.user_id == selectedUseriD
                })
            }         

            dispatch(notesActions.setFilterResult(results))
        }
        
    }

    const filterNotesUser = (value) => {
        setSelectedUserId(value.data.value)
        if (usersOptions) {
            setSelectedUser(usersOptions.find(item => item.value == value.data.value))
        }
        let arr = sortedPermittedNotes()

        if (arr) {            
            // let results = arr.filter(item => item.user_id == value.data.value)
            let results = arr
            if (value.data.value) {
                results = arr.filter(item => {
                    // value.data.value == 'System' ? item.user_id == 0 : item.user_id == value.data.value
                    if (value.data.value == 'System') {
                        return  item.user_id == 0 || item.user_id == null
                    } 
                    
                    return item.user_id == value.data.value
                })
            }

            if (keyword) { //keyword search
                results = results.filter(item => item.note?.toLowerCase().includes(keyword?.toLowerCase()) 
                || item.assignee_resolved_note?.toLowerCase().includes(keyword?.toLowerCase())
                || item.resolved_note?.toLowerCase().includes(keyword?.toLowerCase()))
            } 
            if (selectedActionId !== null) { //action
                results = results.filter(item => item.note_action_id == selectedActionId)
            }
            if (selectedNoteTypeId !== null) { //type
                results = results.filter(item => item.note_type_id == selectedNoteTypeId)
            }     
            
            if (taskVsNotes) {
                if (taskVsNotes == 'notes') {
                    results = results.filter(item => !item.is_task)
                }

                if (taskVsNotes == 'task') {
                    results = results.filter(item => item.is_task && !item.assignee_resolved && !item.resolved)
                }

                if (taskVsNotes == 'task_all') {
                    results = results.filter(item => item.is_task)
                }
                
            } 

            dispatch(notesActions.setFilterResult(results))
        }
        
    }

    const filterNotesHandler = (value) => {        
        setSelectedActionId(value.data.value)
        let arr = sortedPermittedNotes()        

        if (arr) {
            // let results = arr.filter(item => item.note_action_id == value.data.value)
            let results = arr
            if (value.data.value) {
                results = arr.filter(item => item.note_action_id == value.data.value)
            }

            if (keyword) { //keyword search
                results = results.filter(item => item.note?.toLowerCase().includes(keyword?.toLowerCase()) 
                || item.assignee_resolved_note?.toLowerCase().includes(keyword?.toLowerCase())
                || item.resolved_note?.toLowerCase().includes(keyword?.toLowerCase()))
            } 
            if (selectedUseriD !== null) { //user
                // results = results.filter(item => item.user_id == selectedUseriD)
                results = results.filter(item => {
                    // value.data.value == 'System' ? item.user_id == 0 : item.user_id == value.data.value
                    if (selectedUseriD == 'System') {
                        return  item.user_id == 0
                    } 
                    
                    return item.user_id == selectedUseriD
                })
            } 
            if (selectedNoteTypeId !== null) { //type
                results = results.filter(item => item.note_type_id == selectedNoteTypeId)
            }

            if (taskVsNotes) {
                if (taskVsNotes == 'notes') {
                    results = results.filter(item => !item.is_task)
                }

                if (taskVsNotes == 'task') {
                    results = results.filter(item => item.is_task && !item.assignee_resolved && !item.resolved)
                }

                if (taskVsNotes == 'task_all') {
                    results = results.filter(item => item.is_task)
                }
                
            } 
            

            dispatch(notesActions.setFilterResult(results))
        }
        
    }

    const filterNotesType = (value) => {    
        setSelectedActionId(null)    
        setSelectedNoteTypeId(value.data.value)

        let arr = sortedPermittedNotes()       

        if (arr) {
            // let results = arr.filter(item => item.note_type_id == value.data.value)
            let results = arr
            if (value.data.value) {
                results = arr.filter(item => item.note_type_id == value.data.value)
            }
            if (keyword) { //keyword search
                results = results.filter(item => item.note?.toLowerCase().includes(keyword?.toLowerCase()) 
                || item.assignee_resolved_note?.toLowerCase().includes(keyword?.toLowerCase())
                || item.resolved_note?.toLowerCase().includes(keyword?.toLowerCase()))
            } 
            if (selectedUseriD !== null) { //user
                // results = results.filter(item => item.user_id == selectedUseriD)
                results = results.filter(item => {
                    // value.data.value == 'System' ? item.user_id == 0 : item.user_id == value.data.value
                    if (selectedUseriD == 'System') {
                        return  item.user_id == 0
                    } 
                    
                    return item.user_id == selectedUseriD
                })
            } 
            // if (selectedActionId !== null) { //action
            //     results = results.filter(item => item.note_action_id == selectedActionId)
            // }   
  
			
            if (taskVsNotes) {
                if (taskVsNotes == 'notes') {
                    results = results.filter(item => !item.is_task)
                }

                if (taskVsNotes == 'task') {
                    results = results.filter(item => item.is_task && !item.assignee_resolved && !item.resolved)
                }

                if (taskVsNotes == 'task_all') {
                    results = results.filter(item => item.is_task)
                }
                
            } 

            dispatch(notesActions.setFilterResult(results))
        }
    }

    const searchKeywordHandler = (value) => {    
      
        setKeyword(value.data.value)
        let arr = sortedPermittedNotes()

        if (arr) {
            // let results = arr.filter(item => item.notes?.toLowerCase().includes(value.data.value?.toLowerCase()))
            let results = arr
            if (value.data.value && value.data.value != '') {
                results = arr.filter(item => item.note?.toLowerCase().includes(value.data.value?.toLowerCase()) 
                || item.assignee_resolved_note?.toLowerCase().includes(value.data.value?.toLowerCase())
                || item.resolved_note?.toLowerCase().includes(value.data.value?.toLowerCase()))
            }

            if (!value.data.value || value.data.value == '') {
                results = arr
            }
            if (selectedUseriD !== null) { //user
                // results = results.filter(item => item.user_id == selectedUseriD)
                results = results.filter(item => {
                    // value.data.value == 'System' ? item.user_id == 0 : item.user_id == value.data.value
                    if (selectedUseriD == 'System') {
                        return  item.user_id == 0
                    } 
                    
                    return item.user_id == selectedUseriD
                })
            } 
            if (selectedNoteTypeId !== null) { //type
                results = results.filter(item => item.note_type_id == selectedNoteTypeId)
            }
            if (selectedActionId !== null) { //action
                results = results.filter(item => item.note_action_id == selectedActionId)
            }
            if (taskVsNotes) {
                if (taskVsNotes == 'notes') {
                    results = results.filter(item => !item.is_task)
                }

                if (taskVsNotes == 'task') {
                    results = results.filter(item => item.is_task && !item.assignee_resolved && !item.resolved)
                }

                if (taskVsNotes == 'task_all') {
                    results = results.filter(item => item.is_task)
                }
                
            } 
           
            dispatch(notesActions.setFilterResult(results))
        }
    }

    const clearFilters = () => {
        dispatch(notesActions.setFilterResult(null))
        setSelectedUser(null)
        setSelectedUserId(null)
        setSelectedActionId(null)
        setSelectedNoteTypeId(null)
        setTaskVsNotes(null)
        setKeyword(null)
    }

    const [noteActionsValue, setNoteActionsValue] = useState(noteActionsOptions())


    useEffect(() => {
        if (noteActionsOptions()) {
            let filteredOptions = noteActionsOptions().filter(item => item.note_type_id == selectedNoteTypeId)

            setNoteActionsValue(filteredOptions)
        }

    }, [selectedNoteTypeId])
   
    return <div className={classes.container}>
        <span>Filters</span>
        <InputBox label={'Keyword'} action={searchKeywordHandler} currentValue={keyword} setStyle={'bk_white'} isAFilter={true}/>
        <CustomSelect label={'Created by'} optionsData={usersOptions} preSelectedValue={selectedUseriD} action={filterNotesUser} hasRemove={true} isAFilter={true}/>
        <CustomSelect label={'Notes vs Tasks'} optionsData={NOTES_VS_TASKS} preSelectedValue={taskVsNotes} action={filterNotesVSTasks} hasRemove={true} isAFilter={true}/>
        <CustomSelect label={'Note Type'} optionsData={permittedNoteTypes} preSelectedValue={selectedNoteTypeId} action={filterNotesType} hasRemove={true} isAFilter={true}/>
        <CustomSelect label={'Actions'} optionsData={noteActionsValue} preSelectedValue={selectedActionId} action={filterNotesHandler} hasRemove={true} isAFilter={true}/>   
        
        <Button click={clearFilters} btnStyle={'btn_light_grey'}>Clear</Button>
    </div>
}

export default NotesFilters
